module.exports = __webpack_public_path__ + "img/TrafficWarning.1c3bfcf0.svg";